import { registerMockAPI } from '~/mocks/mockApis';

import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT, SMART_SEARCH_PARAMS } from '~/constants';

import { smartSearchKeys } from './keys';

import type { TypeGetSmartSearchFrequentQuestionsResponse, TypeSmartSearchFAQItem } from '~/types/smart-search.types';

/**
 * [스마트검색] 자주 묻는 질문 목록 조회 API
 */
const fetchFrequentQuestions = async (): Promise<TypeSmartSearchFAQItem[]> => {
  const { data } = await axiosInstance.get<TypeGetSmartSearchFrequentQuestionsResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_SMART_SEARCH_FREQUENT_QUESTIONS,
    { params: { productCode: SMART_SEARCH_PARAMS.PRODUCT_CODE, serviceType: SMART_SEARCH_PARAMS.SERVICE_TYPE } }
  );
  return data.data;
};

/**
 * [스마트검색] 자주 묻는 질문 목록 조회 Query Hook
 */
export const useGetSmartSearchFrequentQuestions = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: smartSearchKeys.frequentQuestions(),
    queryFn: fetchFrequentQuestions,
    staleTime: 1000 * 60 * 30,
    enabled: options?.enabled ?? true,
    meta: { silent: true, background: true },
  });
};

registerMockAPI<TypeGetSmartSearchFrequentQuestionsResponse>({
  method: 'get',
  endpoint: '/api-delivery-agency/smart-search/frequent-questions',
  label: '스마트검색/자주 묻는 질문',
  scenarios: [
    {
      name: '정상 응답',
      response: {
        data: [
          { question: '배송 완료 시간은 언제인가요?' },
          { question: '설이나 추석 등 명절 연휴에도 배송이 운영되나요?' },
          { question: '안심번호(050 등)를 사용하는 고객에게도 알림톡이 전송되나요?' },
          { question: '운송장 용지가 부족합니다. 어떻게 신청하나요?' },
          { question: '새벽 배송 가능 지역을 엑셀 파일 등으로 확인할 수 있나요?' },
        ],
      },
    },
    {
      name: '빈 배열 — 섹션 숨김',
      response: { data: [] },
    },
  ],
});
